<template>
	<div>	
		<div class="nutnosti-title">Cetin:</div>
		<div v-if="! loading">
			<div v-if="cetinHold" class="cetin-vysledek-card zmensit">
				{{ cetinHold }}
			</div>
			<div
				v-else-if="
					results.hasOwnProperty('finalNutnosti') &&
					results.finalNutnosti.length > 0 &&
					results.hasOwnProperty('finalAttributy') &&
					results.finalAttributy.length > 0
				"
				class="nutnosti cetin-vysledek-card zmensit"
			>
				<div
					v-if="results.finalNutnosti.length"
					v-for="x of results.finalNutnosti"
					:key="x"
				>
					{{ x }} - {{ translateNutnosti[x] }}
				</div>
				<div
					v-if="results.finalAttributy.length"
					v-for="x of results.finalAttributy"
					:key="x"
				>
					{{ x }} {{ x === "Metalická" ? "" : "Mbps" }}
				</div>

				<div v-if="results.cetinToBeAvailable.length">
					<button @click="showToBeReadyFn">Připravované</button>
					<div v-if="showToBeReady && results.cetinToBeAvailable.length">
						<div
							v-for="(y, index) of results.cetinToBeAvailable"
							:key="index"
						>
							{{ y.rychlost }}Mbps - {{ y.kdy.split(" ")[0] }}
							{{
								y.kdy.split(" ")[1] === "months"
									? "měsice"
									: y.kdy.split(" ")[1]
							}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile> 
		</div>
	</div>
</template>

<script>
export default {
	name: 'CetinResult',

	props: {
		results: { type: Object, default: {} },
		loading: { type: Boolean },
		cetinHold: { type: String },
	},

	data () {
		return {
			showToBeReady: false,
			translateNutnosti: {
				"10": "OK",
				"20": "Nějaké problémy",
				"30": "S problémy",
				"40": "S problémy",
				"50": "Nelze"
			},
		}
	},

	methods: {
		showToBeReadyFn() {
			this.showToBeReady = !this.showToBeReady;
		},

	}
}
</script>

<style lang="stylus" scoped>
.nutnosti
	display flex
	flex-direction column

.nutnosti-title
	margin-top 20px
	font-size 24px
	font-weight bold
	border-top 1px solid #4CA5F9

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

@media (max-width 1000px)
	.zmensit
		width 100%

</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/CetinResult.vue